import React, { useState } from 'react';
import { Layout } from 'tea-component';
import Tabs from '@intelligence/components/NewIconTabs';
import NewReleaseMobileGame from './MobileGame';
import NewReleasePCGame from './PCGame';
import NewReleaseConsoleGame from './ConsoleGame';
import '@/pages/intelligence/assets/scss/TopCharts/MobileGames/index.scss';
import { history, useIntl } from 'umi';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';

const { Content } = Layout;


export default function MobileGames(props: any) {
  const [activeId, setActiveId] = useState(props?.match?.params?.tab || 'MobileGames');
  const [bodyLoading, setBodyLoading] = useState(false);
  const { formatMessage } = useIntl();

  const tabs = [
    {
      id: 'MobileGames',
      label: formatMessage({ id: 'dbi_label_mobile_games' }),
      component: <NewReleaseMobileGame />,
    },
    {
      id: 'PCGames',
      label: formatMessage({ id: 'dbi_label_pc_games' }),
      component: <NewReleasePCGame />
    },
    {
      id: 'ConsoleGames',
      label: formatMessage({ id: 'dbi_label_console_games' }),
      component: <NewReleaseConsoleGame />,
    },
  ];

  return (
    <Content>
      <Content.Header
        title={formatMessage({ id: 'dbi_label_new_release_games' })}
        className="contentHead-normal">
        <div className="header-tab">
          <Tabs
            ceiling
            newMarkIdsMappingKey="PotentialNewReleaseGames"
            tabs={tabs}
            animated={false}
            activeId={activeId}
            onActive={(tab) => {
              setActiveId(tab.id);
              setBodyLoading(true);
              setTimeout(() => {
                setBodyLoading(false);
              }, 0);
              history.replace(
                `/intelligence/potential/newReleaseGames/${tab.id}`,
              );
            }}
          />
        </div>
      </Content.Header>
      {bodyLoading ? null : (
        <Content.Body full>
          <MarqueeBanner />
          {tabs.map((e) => <div key={e.id}>{e.id == activeId ? e.component : ''}</div>)}
        </Content.Body>
      )}
    </Content>
  );
}

// export default connect((state: any) => {
//   return {
//     topchartsState: state[DBI_TOPCHARTS],
//   };
// })(MobileGames);
